// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileZipFilledSvg from "@ant-design/icons-svg/es/asn/FileZipFilled";
import AntdIcon from '../components/AntdIcon';

var FileZipFilled = function FileZipFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileZipFilledSvg
  }));
};

FileZipFilled.displayName = 'FileZipFilled';
export default React.forwardRef(FileZipFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileZipFilled.js
// module id = 1163
// module chunks = 0